import React from 'react';

export const Sponsor = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5039 4.36531C10.5039 5.67164 9.38462 6.73063 8.00391 6.73063C6.62319 6.73063 5.50391 5.67164 5.50391 4.36531C5.50391 3.05899 6.62319 2 8.00391 2C9.38462 2 10.5039 3.05899 10.5039 4.36531Z"
        stroke="#232323"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.74963 11.2304C3.73665 10.8164 3.3905 10.4913 2.97649 10.5043C2.56248 10.5173 2.23738 10.8634 2.25037 11.2774L3.74963 11.2304ZM6.07727 14.0011V13.2511C6.07056 13.2511 6.06385 13.2512 6.05714 13.2514L6.07727 14.0011ZM9.92273 14.0011L9.94286 13.2514C9.93615 13.2512 9.92944 13.2511 9.92273 13.2511V14.0011ZM13.7496 11.2774C13.7626 10.8634 13.4375 10.5173 13.0235 10.5043C12.6095 10.4913 12.2634 10.8164 12.2504 11.2304L13.7496 11.2774ZM12.2504 11.1508C12.2634 11.5648 12.6095 11.8899 13.0235 11.8769C13.4375 11.8639 13.7626 11.5178 13.7496 11.1038L12.2504 11.1508ZM9.92273 8.38007V9.13007C9.92944 9.13007 9.93615 9.12998 9.94286 9.1298L9.92273 8.38007ZM6.07727 8.38007L6.05714 9.1298C6.06385 9.12998 6.07056 9.13007 6.07727 9.13007V8.38007ZM2.25037 11.1038C2.23738 11.5178 2.56248 11.8639 2.97649 11.8769C3.3905 11.8899 3.73665 11.5648 3.74963 11.1508L2.25037 11.1038ZM2.25037 11.2774C2.31351 13.2905 4.07282 14.8052 6.09741 14.7508L6.05714 13.2514C4.77938 13.2857 3.78448 12.3416 3.74963 11.2304L2.25037 11.2774ZM6.07727 14.7511H9.92273V13.2511H6.07727V14.7511ZM9.90259 14.7508C11.9272 14.8052 13.6865 13.2905 13.7496 11.2774L12.2504 11.2304C12.2155 12.3416 11.2206 13.2857 9.94286 13.2514L9.90259 14.7508ZM13.7496 11.1038C13.6865 9.09066 11.9272 7.57596 9.90259 7.63034L9.94286 9.1298C11.2206 9.09548 12.2155 10.0396 12.2504 11.1508L13.7496 11.1038ZM9.92273 7.63007H6.07727V9.13007H9.92273V7.63007ZM6.09741 7.63034C4.07282 7.57596 2.31351 9.09066 2.25037 11.1038L3.74963 11.1508C3.78448 10.0396 4.77938 9.09548 6.05714 9.1298L6.09741 7.63034Z"
        fill="#232323"
      />
    </svg>
  );
};
